import { createApi } from "@reduxjs/toolkit/query/react";

import { createAuthBaseQuery } from "../../client/serviceBaseQuery";
import type { UserInfoDTO } from "./types";

export const userInfoService = createApi({
  reducerPath: "userInfoService",
  baseQuery: createAuthBaseQuery(),
  tagTypes: ["UserInfo"],
  endpoints: (builder) => ({
    getUserInfo: builder.query<UserInfoDTO, { userInfoUri: string }>({
      query: (data) => data.userInfoUri,
      providesTags: [{ type: "UserInfo" }],
    }),
  }),
});

export const { useGetUserInfoQuery } = userInfoService;
